import { Component, OnInit } from '@angular/core';
import { AlertController, NavController, Platform } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { handleCopy } from 'src/app/angular-wallet-base/utils';
import { ClipboardService } from 'ngx-clipboard';
import { Clipboard } from "@ionic-native/clipboard/ngx";
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { GetPurchaseHistoryAction } from 'src/app/angular-wallet-base/actions/wallet.actions';
import { WalletService } from 'src/app/angular-wallet-base/services/wallet.service';
import { AuthService } from 'src/app/angular-wallet-base/services/auth.service';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { RoutingService } from '../../../angular-wallet-base/services/routing.service';

interface SuccessOrderDetails {
  amount: string
  amountOld: string
  amountFiat: string
  amountFiatOld: string
  amountFiatDisplay: string
  amountFiatDisplayOld: string
  swap_amount_fiat_display: string
  swap_amount_fiat: string
  amountCrypto: string
  amountCryptoOld: string
  amount_to_swap: string
  asset: string
  currencyCode: string
  fiatCurrencyCode: string
  currencySymbol: string
  payWith: string
  payWithDisplay: string
  promo: string
  isNewUser: boolean
  bonus: number
  token_fiat_value: string
  swap_token_fiat_value: string
  token_fiat_value_old: string
  feeAmount: string
  feeAmount_old: string
  discount: string
  totalSilver: number
  totalGold: number
  oneLodeSilver: number
  oneLodeGold: number
  cart: []
  isTokenAmountChange: boolean
  quoteId?: string
  slippageTolerance: number
  priceImpact: any
  minimumAmount: any
  swappingPair: string
  routeSwapPair1: string
  routeSwapPair2: string
  isNormalSwap: boolean
  feeAmount2: string
  paymentId: string,
  fiat_to_token: boolean,
  primeRate?: string
}
@Component({
  selector: 'success-order',
  templateUrl: './success-order.component.html',
  styleUrls: ['./success-order.component.scss']
})
export class SuccessOrderComponent implements OnInit {

  public isDesktopMode;
  public paywith = '';
  public successMessage1;
  public successMessage2;
  public successMessage3;
  public coinsOrTokens: 'Coins' | 'Tokens';
  public successOrderDetails: SuccessOrderDetails;
  public hidePayWith: boolean;
  public walletType;

  constructor(
    public appMode: AppModeService,
    private nav: NavController,
    private route: ActivatedRoute,
    private iab: InAppBrowser,
    private platform: Platform,
    private clipboard: Clipboard,
    private clipboardService: ClipboardService,
    private alertController: AlertController,
    private translate: TranslateService,
    private store: Store,
    private walletService: WalletService,
    private routingService: RoutingService

  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  ngOnInit() {
    this.route.queryParams.subscribe(async (params) => {
      this.successOrderDetails = JSON.parse(params.successOrderDetails);

      Logger.info(params, this.successOrderDetails);

      this.paywith = this.successOrderDetails.payWith;
      this.hidePayWith = (this.successOrderDetails.payWith == 'eth' || this.successOrderDetails.payWith == 'btc') ? true : false;
      this.coinsOrTokens = this.successOrderDetails.asset != 'LODE' ? 'Coins' : 'Tokens';
      this.setSuccessMessagesRegardingPayWith(this.paywith);
      this.store.dispatch(new GetPurchaseHistoryAction());
    });
    this.walletType = this.walletService.getWalletType();
  }

  setCurrencyCode() {
    if (this.successOrderDetails.payWith === 'eth' || this.successOrderDetails.payWith === 'btc') {
      return this.successOrderDetails.currencyCode;
    }
    else {
      this.successOrderDetails.fiatCurrencyCode;
    }
  }

  async setSuccessMessagesRegardingPayWith(payWith) {
    switch (payWith) {
      case 'bankTransfer':
        this.successMessage1 = await this.translate.get("buy_assets.bank_transfer_success_msg_one").toPromise();
        this.successMessage2 = await this.translate.get("buy_assets.bank_transfer_success_msg_two").toPromise();
        this.successMessage3 = await this.translate.get("buy_assets.bank_transfer_success_msg_three").toPromise();
        break;
      case 'myMetals':
        this.successMessage2 = await this.translate.get("buy_assets.metals_success_msg").toPromise();
        break;
      case 'eth':
        this.successMessage2 = await this.translate.get("buy_assets.crypto_success_msg").toPromise();
        break;
      case 'btc':
        this.successMessage2 = await this.translate.get("buy_assets.crypto_success_msg").toPromise();
        break;
      default:
        break;
    }
  }

  async viewWireModal(type) {
    let pdfUrl;
    if (type === 'wire') {
      pdfUrl = 'https://lode.one/bank_wire_instructions';
    } else if (type === 'sepa') {
      pdfUrl = 'https://lode.one/sepa/';
    }
    this.iab.create(pdfUrl, '_system', 'location=yes');
  }

  async backToHome() {
    await this.routingService.goHome();
  }

  makeAnotherPurchase() {
    this.nav.navigateRoot(['/vault-intro']);
  }

  getSwapThrough() {
    let swap_start;
    let swap_middle;
    let swap_end;
    if (this.successOrderDetails.isNormalSwap) {
      swap_start = (this.successOrderDetails.swappingPair.split("_", 2))[0];
      swap_end = (this.successOrderDetails.swappingPair.split("_", 2))[1];
      return swap_start + " -> " + swap_end;
    } else {
      swap_start = (this.successOrderDetails.routeSwapPair1.split("_", 2))[0];
      swap_middle = (this.successOrderDetails.routeSwapPair1.split("_", 2))[1];
      swap_end = (this.successOrderDetails.routeSwapPair2.split("_", 2))[1];
      return swap_start + " -> " + swap_middle + " -> " + swap_end;
    }
  }
  async doCopy() {
    await handleCopy(this.successOrderDetails.paymentId, this.platform, this.clipboard, this.alertController, this.translate, this.clipboardService, null);
  }
}
